import "20220101/google-analytics.js";
import "stylesheets/20220101/embed.scss";
import "20220101/patchwork-widget.js";
import "20220101/scrollable-widget.js";
import "20220101/grid-widget.js";
import "20220101/stacking-grid-widget.js";
import "20220101/gallery-widget.js";
import "20220101/personalized-widget.js";
import "20220101/looff-widget.js";
import "20220101/event-widget.js";
import "20220101/photo-modal.js";
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
window.L2H_20220101_loaded = true;
